import { FC } from 'react';
import { Modal } from 'antd';
import AddUpdateSetting from './addUpdateSetting';
import UpdateSettingList from './UpdateSettingList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadUpdateSettings } from './UpdateSettingSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
const UpdateSetting: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, setEditBodySize, editBodySize } = React.useContext(CommonContext) as CommonContextType;
/*   const UpdateSettings = useSelector(
    (state: AppState) => state.UpdateSettings
  ); */
  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditBodySize(null)
    setModelChange(false);
  };
  
  React.useEffect(() => {

    dispatch(loadUpdateSettings());
  },[dispatch]);
  
  return (
    <div className='padding' style={{ background: '#ffffff'}}>
      {contextHolder}
      <br></br>
      <h2>Update Settings
        <button className='top-button' onClick={showModal}>Create</button>
      </h2>
      <UpdateSettingList />
      <Modal title={editBodySize?.id ? 'Edit Update Setting' : 'Create Update Setting'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddUpdateSetting />
      </Modal>
    </div>
  );
  
};

export default UpdateSetting;